<div style="display: flex; flex-direction: column; column-gap: 10px;">
    <div><strong>Exemptions@if (showTotalAVOnlyText) {
        <span> (Total AV only)</span>
    }:</strong></div>
    @for (exemption of exemptions; track exemption) {
        <div style="margin-left: 10px;">{{ exemption }}</div>
    }
</div>
